import styled from "styled-components";

export const OptionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  border-radius: 1rem;
  background: transparent;
  cursor: pointer;

  span {
    flex-grow: 0;
    flex-shrink: 1;
    flex-basis: auto;
    min-width: 0;
    max-width: 100%;

    font-weight: bold;
    font-size: 1.25rem;
    line-height: 1.2;
    color: ${({ theme }) => theme.palette.neutral.lightest};
    transition: color 0.2s ease;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const IconWrapper = styled.div<{ $customIconSize: number }>`
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
  border-radius: 0.75rem;
  background: ${({ theme }) => `${theme.palette.primary.light}33`};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: ${({ $customIconSize }) => $customIconSize}rem;
    height: ${({ $customIconSize }) => $customIconSize}rem;
    color: ${({ theme }) => theme.palette.primary.medium};
    stroke-width: 2;
  }
`;
